import urlPrefix from "./apiPrefix";

export const putBaseCatalogueVersionUpdate = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue-version/update`;
export const postBaseCatalogueVersionCreate = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue-version/create`;
export const getBaseCatalogueVersionActiveAndDraft = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue-version/activeAndDraft`;
export const deleteBaseCatalogueVersionResetDraft = () => `${urlPrefix.value}/tax-web-control/api/base-catalogue-version/resetDraft`;
